export enum CourtSystemForbiddenType {
  UseConditionsNotAccepted = 'useConditionsNotAccepted',
  MfaNotEnabled = 'mfaNotEnabled',
}
